import type { ReactNode } from "react";

// Eyebrow-titled panel scaffold shared across the Settings sub-panels
// (Appearance, Model, …): a padded `.box bg-surface` with a small tracked
// eyebrow title and optional sub line above the content. Defined once so the
// panels can't drift; see @adr SPARK-0014-design-primitives-single-source@1.
export function SettingsCard({
  title,
  sub,
  children,
}: {
  title: string;
  sub?: string;
  children: ReactNode;
}) {
  return (
    <div className="box bg-surface p-6">
      <div className="text-smycles-micro tracking-[0.25em] text-ink-muted">{title}</div>
      {sub ? <div className="mt-1 text-smycles-meta text-ink-muted">{sub}</div> : null}
      <div className="mt-4">{children}</div>
    </div>
  );
}
